import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { updateExportAssetsRules } from '@api/exportAssets';

import { ESnackbarTypes } from '@enums/common';

import { EXPORT_ASSET_RULES, EXPORT_ASSET_RULES_UPDATE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateUpdateExportAssetsRules = (onSettledCallbacks?: Array<() => void>) => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleUpdateExportAssetsRules,
		isLoading: isLoadingUpdateExportAssetRules,
	} = useMutation({
		mutationKey: [EXPORT_ASSET_RULES_UPDATE],
		mutationFn: updateExportAssetsRules,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportAssetsUpdateRulesSuccess,
				type: ESnackbarTypes.success,
			}));

			if (onSettledCallbacks?.length) {
				onSettledCallbacks.forEach((callback) => callback());
			}

			return queryClient.invalidateQueries([EXPORT_ASSET_RULES]);
		},
	});

	return {
		handleUpdateExportAssetsRules,
		isLoadingUpdateExportAssetRules,
	};
};
